// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3ebKz","footer":"ReportModalFilter_footer__1yYIm"};